export const VALIDATION_ERROR_TOOLTIP_TEXT =
  "There was an issue validating the policy. Click to retry.";

export const MODAL_TITLE: Record<"add" | "edit" | "replace", string> = {
  add: "Add additional interest",
  edit: "Edit additional interest",
  replace: "Replace billing additional interest",
};

export const DEFAULT_ERROR_MESSAGE = "Sorry, something went wrong.";
export const VALIDATION_ERROR_MESSAGE = `${DEFAULT_ERROR_MESSAGE} Please refresh the page.`;
